/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventdetectorEvent } from './EventdetectorEvent';
import {
    EventdetectorEventFromJSON,
    EventdetectorEventFromJSONTyped,
    EventdetectorEventToJSON,
} from './EventdetectorEvent';

/**
 * 
 * @export
 * @interface EventdetectorEventList
 */
export interface EventdetectorEventList {
    /**
     * 
     * @type {Array<EventdetectorEvent>}
     * @memberof EventdetectorEventList
     */
    records?: Array<EventdetectorEvent>;
}

/**
 * Check if a given object implements the EventdetectorEventList interface.
 */
export function instanceOfEventdetectorEventList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorEventListFromJSON(json: any): EventdetectorEventList {
    return EventdetectorEventListFromJSONTyped(json, false);
}

export function EventdetectorEventListFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorEventList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(EventdetectorEventFromJSON)),
    };
}

export function EventdetectorEventListToJSON(value?: EventdetectorEventList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(EventdetectorEventToJSON)),
    };
}

